import { redirect, createFileRoute } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

/**
 * The flow editor folded into the detail page — the detail canvas now shows the
 * full flow (steps, previews, metrics, inline variant toggle) and swaps
 * templates in place, so this route just redirects back to it.
 */
export const Route = createFileRoute('/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId/edit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: paths.dashboard
        .tenant(params.orgId, params.clientId)
        .flowDetail(params.flowId),
    });
  },
});
